import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getUserAttribute, UserAttributes } from "shared-auth";
import { parseQuery } from "shared/utils/http";
import { UserManager } from "core";

function withArtistRef<P>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<P>>
): React.FC<React.PropsWithChildren<P>> {
  return (props) => {
    const location = useLocation();
    const history = useHistory();
    const { artistref } = parseQuery(location.search);

    useEffect(() => {
      const performerId = getUserAttribute(UserAttributes.UserIdPerformer);

      UserManager.artistRef = performerId || artistref || UserManager.artistRef;

      if (artistref) history.push(location.pathname);
    }, [artistref, history, location.pathname]);

    return <WrappedComponent {...props} />;
  };
}

export default withArtistRef;
